import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';

type Props = TooltipProps;

export const Tooltip = ({ children, ...props }: Props) => {
  return (
    <MuiTooltip {...props} enterTouchDelay={0}>
      {children}
    </MuiTooltip>
  );
};

Tooltip.displayName = 'Tooltip';
